import React, { useState } from 'react';
import PrintButton from '../../../../../Components/Button/PrintButton';
import MediaViewerModal from '../../../../../Components/MediaViewer/MediaViewerModal';
import { useAppContext } from '../../../../../Services/AppContext';
import useTranslation from '../../../../../Hooks/useTranslation';
import { Orientation } from '../../../../Base/Enums/Orientation.enum';
import { Flyer } from '../../../Enums/Flyer.enum';
import useWorkplaceRole from '../../../../Workplace/Hooks/useWorkplaceRole';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

interface Props {
	workplaceId: string;
	workplaceMemberId: string;
	flyerType: Flyer;
	buttonTitle?: string;
	onClose?: () => void;
}
const FlyerPrintButton: React.FC<Props> = ({
	workplaceId,
	workplaceMemberId,
	flyerType,
	buttonTitle = 'component.workplaceAndPatients.codePrint',
	onClose,
}) => {
	const [file, setFile] = useState<any>();
	const { socketUrl, userData } = useAppContext();
	const { t } = useTranslation();
	const userId = userData.id;
	const { isDoctor } = useWorkplaceRole({ userId, workplaceId });

	const getFileByFlyerType = () => {
		let url = `${socketUrl}/workplaces/${workplaceId}/members/${workplaceMemberId}/print`;
		switch (flyerType) {
			case Flyer.MEDDI_BABY_LATAM:
				url += '/patient-invitation-code/pdf?healthPlanCode=meddibaby';
				return {
					id: '',
					name: t('component.workplaceAndPatients.codePrintInvitation'),
					displayName: t('component.workplaceAndPatients.codePrintInvitation'),
					type: 'pdf',
					preview: url,
					download: url,
				};
			case Flyer.MEDDI_DIABETES_LATAM:
				url += '/patient-invitation-code/pdf?healthPlanCode=diabetes';
				return {
					id: '',
					name: t('component.workplaceAndPatients.codePrintInvitation'),
					displayName: t('component.workplaceAndPatients.codePrintInvitation'),
					type: 'pdf',
					preview: url,
					download: url,
				};
			case Flyer.E_ARCHIVE_INVITATION:
				url += '/patient-invitation-code/pdf';
				return {
					id: '',
					name: t('component.workplaceAndPatients.codePrintInvitation'),
					displayName: t('component.workplaceAndPatients.codePrintInvitation'),
					type: 'pdf',
					preview: url,
					download: url,
				};
			case Flyer.E_ARCHIVE_INVITATION_CHILDREN:
				url += '/children-pair-code/pdf';
				return {
					id: '',
					name: t('component.workplaceAndPatients.codePrint'),
					displayName: t('component.workplaceAndPatients.codePrint'),
					type: 'pdf',
					preview: url,
					download: url,
				};
			case Flyer.E_ARCHIVE_WORKPLACE:
				url += '/patient-code/pdf?workplace=true';
				return {
					id: '',
					name: t('component.workplaceAndPatients.codePrintInvitation'),
					displayName: t('component.workplaceAndPatients.codePrintInvitation'),
					type: 'pdf',
					preview: url,
					download: url,
				};
			case Flyer.E_ARCHIVE:
			default:
				url += '/patient-code/pdf';
				return {
					id: '',
					name: t('component.workplaceAndPatients.codePrintInvitation'),
					displayName: t('component.workplaceAndPatients.codePrintInvitation'),
					type: 'pdf',
					preview: url,
					download: url,
				};
		}
	};

	const handlePrint = () => {
		const fileToViewer = getFileByFlyerType();
		setFile(fileToViewer);
	};

	const handleClose = () => {
		setFile(null);
		onClose?.();
	};

	if (!isDoctor && flyerType === Flyer.E_ARCHIVE) {
		return null;
	}

	return (
		<>
			<LinkButton
				title={buttonTitle}
				theme={Theme.BLUE}
				onClick={handlePrint}
			/>
			<MediaViewerModal opened={!!file} onClose={handleClose} file={file} />
		</>
	);
};

export default FlyerPrintButton;
